import { registerPreviewTokenFetcher } from "@workspace/shared";
import { fetchPreviewTokenApi } from "./preview";
import { store } from "@/redux/store";
import { setPreviewToken } from "@/redux/slices/previewSlice";

export const bootstrapPreview = async () => {
  registerPreviewTokenFetcher(fetchPreviewTokenApi);
  // Eagerly fetch the preview token on app load
  try {
    const tokenData = await fetchPreviewTokenApi();
    // Dispatch the token to the store
    store.dispatch(setPreviewToken(tokenData));
  } catch (error) {
    console.error("Failed to fetch preview token eagerly", error);
  }
};